import { Box } from '@mui/material';
import { useRef, useEffect, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface FileUploadProps {
  title: string;
  onFileChange: (file: File | null, lang: string) => void;
  lang: string; // 언어
  fileName: string; // 각 언어별로 파일명을 상태로 관리
}

export default function UploadFileBtn({ title, onFileChange, lang, fileName }: FileUploadProps) {
  // 다국어
  const { t } = useTranslation(); // useTranslation 훅 사용

  // 파일 입력 핸들러
  const fileInputHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const target = event.target as HTMLInputElement;
    const files = target.files;
    if (files && files[0]) {
      // console.log('fileInputHandler', files[0], lang);
      onFileChange(files[0], lang); // 파일 변경 콜백 호출
    }
  };

  // useEffect(() => {
  //   console.log('lang=====s====', lang);
  // }, [lang]);

  const containerStyle = {
    display: 'flex',
    gap: '8px',
    borderRadius: '8px',
    padding: '5px 8px',
    border: '1px solid #ccc',
    width: '330px',
    height: '36px',
    alignItems: 'center',
    margin: 'auto 0px'
  };
  const buttonStyle = {
    display: 'flex', // 플렉스 박스 설정
    justifyContent: 'center', // 가로 중앙 정렬
    alignItems: 'center', // 세로 중앙 정렬
    maxWidth: '140px', // 최대 너비 90px로 제한
    padding: '3px', // 좌우 패딩을 추가하여 여유 공간 제공
    height: '100%', // 높이를 부모 높이에 맞춤
    backgroundColor: '#EFEFEF',
    cursor: 'pointer',
    border: '0.5px solid black',
    borderRadius: '3px',
    fontSize: '0.75rem',
    color: '#000000'
  };
  const textStyle = {
    fontSize: '0.75rem',
    color: '#999',
    width: '190px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  };
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: { xs: 'left', sm: 'center' }, width: { xs: '100%', sm: 'auto' } }} className={`${lang}`}>
      <label htmlFor={title}>
        <div style={containerStyle}>
          <div style={buttonStyle}>📂 {t('system_settings.file.choose_file')}</div>

          <p style={textStyle}> {fileName || t('system_settings.file.no_file')}</p>
        </div>
      </label>
      <input type="file" id={title} style={{ display: 'none' }} onChange={fileInputHandler} accept="application/pdf" />
    </Box>
  );
}
